module.exports = __webpack_public_path__ + "img/21.0eed9df9.jpg";